import React from "react";
import Translate from "react-translate-component";
import TranslateWithLinks from "../../Utility/TranslateWithLinks";
export const AccountTransfer = ({
  op,
  linkToAccount,
  fromComponent
}) => {
  if (fromComponent === "proposed_operation") {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.transfer_account"
    }), "\xA0", linkToAccount(op[1].account_id), /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.to"
    }), "\xA0", linkToAccount(op[1].new_owner));
  } else {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TranslateWithLinks, {
      string: "operation.account_transfer",
      keys: [{
        type: "account",
        value: op[1].account_id,
        arg: "account"
      }, {
        type: "account",
        value: op[1].new_owner,
        arg: "to"
      }]
    }));
  }
};